import t, { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');
const validateTileForm = (values) => {
  const errors = {};
  // A poll has no subtitle or description, and the image is optional
  const isPoll = values.type?.value === 'POLL';
  if (!values.title) {
    errors.title = p('nameFieldEmpty');
  }
  if (!values.headingImage && !isPoll) {
    errors.headingImage = p('picFieldCantBeEmpty');
  }
  if (!values.subtitle && !isPoll) {
    errors.subtitle = p('subTitleFieldCantBeEmpty');
  }
  if (!values.endDate) {
    errors.endDate = p('endDateFieldCantBeEmpty');
  }
  if (!values.startDate) {
    errors.startDate = p('startDateFieldCantBeEmpty');
  }
  if (!values.description && !isPoll) {
    errors.description = p('descriptionFieldCantBeEmpty');
  }
  if (!values.answerVisibility) {
    errors.answerVisibility = t(
      'questionaire.answerVisibilityFieldCantBeEmpty'
    );
  }

  return errors;
};
export default validateTileForm;
